// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import {
    useOrderHistoryDebouncedUpdateDraftParameter,
    useOrderHistoryState,
} from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useEffect, useMemo, useState } from "react";

export interface OrderHistoryFilterFieldOrderNumberProps {}

export interface OrderHistoryFilterFieldOrderNumberStyles {
    textField?: TextFieldPresentationProps;
}

export const OrderHistoryFilterFieldOrderNumberStyles: OrderHistoryFilterFieldOrderNumberStyles = {
    textField: filterDrawerProps.textField,
};

const styles = OrderHistoryFilterFieldOrderNumberStyles;

const OrderHistoryFilterFieldOrderNumber: FC<OrderHistoryFilterFieldOrderNumberProps> = () => {
    const { orderNumber } = useOrderHistoryState().draftParameter;
    const debouncedUpdateDraftParameter = useOrderHistoryDebouncedUpdateDraftParameter();
    const [value, setValue] = useState(orderNumber);
    const id = useMemo(uniqueId, []);
    const label = translate("Greif Order #");

    useEffect(() => {
        if (value !== orderNumber) {
            setValue(orderNumber);
        }
    }, [orderNumber]);

    return (
        <FilterDrawerSection title={label} labelFor={id}>
            <TextField
                {...styles.textField}
                id={id}
                data-test-selector="orderHistory_filterOrderNumber"
                onChange={event => {
                    setValue(event.currentTarget.value);
                    debouncedUpdateDraftParameter({ orderNumber: event.currentTarget.value });
                }}
                placeholder={translate("Enter {0}", label)}
                value={value}
            />
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldOrderNumber;
